export const getInitials = (name: string) => name
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((part) => part.charAt(0).toUpperCase())
  .join('');

export const parseUsersTableDate = (value?: string | null) => {
  if (!value) return null;
  const normalized = value.trim();
  const numericValue = Number(normalized);
  const date = /^\d+$/.test(normalized)
    ? new Date(numericValue < 100000000000 ? numericValue * 1000 : numericValue)
    : new Date(normalized);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const getStatusLabel = (status?: string | null) => {
  if (!status) return '-';
  return status
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};